import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { CacheRestoreService } from '@/services/cache-restore-service/cache-restore-service';
import { SessionStorageCacheRestoreService } from '@/services/cache-restore-service/impls/session-storage-cache-restore-service';

/**
 * 缓存恢复服务模块
 */
export const cacheRestoreServiceModule = new ContainerModule((bind) => {
    bind<CacheRestoreService>(CacheRestoreService).to(SessionStorageCacheRestoreService);
});
